import { CompactUserResponse } from '@business/entities/account';
import { CompactOrgResponse } from '../organization';

export type ChannelRuleId = string;

export enum SupportChannelRuleType {
  email = 'email',
  wildcard_email = 'wildcard_email',
  org = 'org',
}

export interface SupportChannelRuleResponse {
  id: ChannelRuleId;
  type: SupportChannelRuleType;
  value: string;
  org?: CompactOrgResponse;
  user: CompactUserResponse;
}

export type SupportChannelRuleRequest = Pick<SupportChannelRuleResponse, 'type' | 'value'> & {
  userId: string;
};
